import { ReactElement } from 'react';

import { Checkbox } from '@dreryk/react-components';
import { BindingCreator } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type WeekendsVisibilityPreferenceFormBeanPart = {
   preferWeekendsVisible: boolean;
};

type WeekendsVisibilityPreferenceFieldProps = {
   register: BindingCreator<WeekendsVisibilityPreferenceFormBeanPart>;
};

export const WeekendsVisibilityPreferenceField = (props: WeekendsVisibilityPreferenceFieldProps): ReactElement => {
   return (
      <Checkbox
         testId={'preferWeekendsVisible'}
         label={translationKeys.showWeekends}
         controller={props.register('preferWeekendsVisible')}
      />
   );
};
